//dependencias
import React, { Component } from 'react';

//componentes
import MateriasPAction from './materiasProfesor'

class Index extends Component {

    render(){
        return(
            <div>
                <MateriasPAction />
            </div>
        );
    }

}
export default Index;